import { Component, Input } from '@angular/core';
import { LeverageLevel } from '../../../../../enum/leverageLevel.enum';
import { TrackingsService } from '../../../../../services/tracking.service';

@Component({
    selector: 'alertbox',
    templateUrl: './alertbox.component.html',
    styleUrls: ['./alertbox.component.scss']
})
export class AlertboxComponent {
    @Input() public leverageLevel: LeverageLevel;

    public constructor(
        private tracking: TrackingsService,
    ) {}

    /**
     * Verifica se o usuário está em um nível avançado de alavancagem
     */
    public get isLeverageWarning() {
        return this.leverageLevel && this.leverageLevel === LeverageLevel.high;
    }

    /**
     * Redireciona usuário para página de transferência
     */
     public redirectExternal(url: string = '') {
        this.tracking.sendMetricsToMixpanel(this.tracking.actionEvents.USER_CLICKED, { element: 'Transferir recursos' });
        window.open(url, '_blank');
    }

}
